```vue
<template>
  <div
    class="case-clients-table"
  >
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <div class="table-container">
      <table
        class="raz"
        cellpadding="0"
        cellspacing="0"
        border="0"
      >
        <TableHeader
          v-if="users.length"
          :class="checkAll || checkSome.length >= 2 ? 'active ' : ''"
        >
          <tr>
            <th class="holder-checkbox w-50">
              <div class="custom-checkbox-group">
                <div class="checkbox-wrap">
                  <input
                    :id="`checkAll_client_in_case_${caseId}`"
                    v-model="checkAll"
                    class="input-checkbox"
                    type="checkbox"
                  >
                  <label :for="`checkAll_client_in_case_${caseId}`" class="label-checkbox">
                    <span>{{ ' ' }}</span>
                  </label>
                  <span
                    class="checkbox-unselect"
                    @click="unselectAll"
                  >{{ checkAll ? 'Unselect All' : 'Select All' }}</span>
                </div>
              </div>
            </th>
            <th class="w-200">
              <div
                v-show="!checkAll && checkSome.length <= 1"
                :id="`sort_client_in_case_${caseId}_by_name`"
                class="table-header-box"
                :class="{
                  'sort-active': sortBy === 'email',
                  'sorted-desc': order === 'desc',
                }"
                @click="sortedBy('email')"
              >
                <UserIcon />
                <span class="header-table-text">Email</span>
                <div class="arrow-icon">
                  <arrowDown class="arrow" />
                </div>
              </div>
            </th>
            <th class="w-100">
              <div
                v-show="!checkAll && checkSome.length <= 1"
                class="table-header-box table-header-box-doesnt-hover"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.4737 3.2H6.73684C6.5135 3.2 6.29931 3.28429 6.14138 3.43431C5.98346 3.58434 5.89474 3.78783 5.89474 4V14.4H0.842105C0.618765 14.4 0.404572 14.3157 0.246647 14.1657C0.0887215 14.0157 0 13.8122 0 13.6V0.8C0 0.587827 0.0887215 0.384344 0.246647 0.234315C0.404572 0.0842854 0.618765 0 0.842105 0H12.6316C12.8549 0 13.0691 0.0842854 13.227 0.234315C13.385 0.384344 13.4737 0.587827 13.4737 0.8V3.2ZM8.42105 4.8H15.1579C15.3812 4.8 15.5954 4.88429 15.7534 5.03431C15.9113 5.18434 16 5.38783 16 5.6V15.2C16 15.4122 15.9113 15.6157 15.7534 15.7657C15.5954 15.9157 15.3812 16 15.1579 16H8.42105C8.19771 16 7.98352 15.9157 7.82559 15.7657C7.66767 15.6157 7.57895 15.4122 7.57895 15.2V5.6C7.57895 5.38783 7.66767 5.18434 7.82559 5.03431C7.98352 4.88429 8.19771 4.8 8.42105 4.8Z"
                    fill="#D7DCE6"
                  />
                </svg>
                <span class="header-table-text">device</span>
              </div>
            </th>
            <th class="w-100">
              <div
                v-show="!checkAll && checkSome.length <= 1"
                class="table-header-box table-header-box-doesnt-hover"
              >
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.0625 0.5C3.17853 0.5 3.28981 0.549386 3.37186 0.637294C3.45391 0.725201 3.5 0.84443 3.5 0.96875V1.4375H10.5V0.96875C10.5 0.84443 10.5461 0.725201 10.6281 0.637294C10.7102 0.549386 10.8215 0.5 10.9375 0.5C11.0535 0.5 11.1648 0.549386 11.2469 0.637294C11.3289 0.725201 11.375 0.84443 11.375 0.96875V1.4375H12.25C12.7141 1.4375 13.1592 1.63504 13.4874 1.98667C13.8156 2.33831 14 2.81522 14 3.3125V13.625C14 14.1223 13.8156 14.5992 13.4874 14.9508C13.1592 15.3025 12.7141 15.5 12.25 15.5H1.75C1.28587 15.5 0.840752 15.3025 0.512563 14.9508C0.184374 14.5992 0 14.1223 0 13.625V5.1875H14V4.25H0V3.3125C0 2.81522 0.184374 2.33831 0.512563 1.98667C0.840752 1.63504 1.28587 1.4375 1.75 1.4375H2.625V0.96875C2.625 0.84443 2.67109 0.725201 2.75314 0.637294C2.83519 0.549386 2.94647 0.5 3.0625 0.5V0.5Z"
                    fill="#D7DCE6"
                  />
                </svg>
                <span class="header-table-text">last sync</span>
              </div>
            </th>
            <th class="w-300">
              <div
                v-if="checkAll || checkSome.length >= 2"
                id="deactivate-all-clients"
                ref="deactivateAllClients"
                class="holder-deactivate-btn"
              >
                <button
                  :id="`deactivate_clients_in_case_${caseId}`"
                  class="btn btn-deactivate"
                  @click.stop="openDeactivatePopup"
                >
                  <span class="btn-span">Remove all</span>
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0.499969C4.47 0.499969 0 4.96997 0 10.5C0 16.03 4.47 20.5 10 20.5C15.53 20.5 20 16.03 20 10.5C20 4.96997 15.53 0.499969 10 0.499969ZM15 14.09L13.59 15.5L10 11.91L6.41 15.5L5 14.09L8.59 10.5L5 6.90997L6.41 5.49997L10 9.08997L13.59 5.49997L15 6.90997L11.41 10.5L15 14.09Z"
                      fill="#D7DCE6"
                    />
                  </svg>
                </button>
                <tooltip v-if="!hasPermission(['manage_contacts'])" :target-ref="$refs.deactivateAllClients">
                  <span>To get access to remove custodians from a case, you need to get permission 'Assign user to case' in this case</span>
                </tooltip>
              </div>
            </th>
          </tr>
        </TableHeader>
        <Loader v-if="loadFlag" :load-flag="loadFlag" />
        <template v-else>
          <CaseClientsItem
            v-if="users.length"
            :clients-list="users"
            @deactivateUser="deleteUser"
            @confirmDeactivateUser="confirmDeactivateUser"
            @resend="resendInvite"
          />
          <p v-else class="no-found">
            No data
          </p>
        </template>
      </table>
    </div>
    <pagination
      v-if="users.length && count !== 1"
      v-model="page"
      :total-pages="count"
      :link-gen="linkGen"
    />
    <CommonDialog
      ref="commonDialogDeleteUser"
    >
      <SuccessIcon />
      <h2 class="dialog-message-title">
        Success!
      </h2>
      <p class="dialog-message-description" style="display:block;">
        Selected custodians were removed
      </p>
    </CommonDialog>
    <DeactivateItemPopUp
      ref="contactsPopup"
      :array-of-checked-users="checkSome"
      :subtitle="'custodian'"
      title="'custodian'"
      :action="'remove'"
      @deactivateArrayOfUsers="confirmDeactivateUserList"
    />
    <InfoDialog
      ref="infoDialog"
      :title="infoDialogData.dialogTitle"
      :subtitle="infoDialogData.dialogSubtitle"
      :text="infoDialogData.dialogText"
      :confirm-btn-text="infoDialogData.confirmBtnText"
      :cancel-btn-text="infoDialogData.cancelBtnText"
      @onConfirm="deleteUser"
    />
    <InfoDialog
      ref="infoDialogDeactivateUserList"
      :title="infoDialogData.dialogTitle"
      :text="infoDialogData.dialogText"
      :confirm-btn-text="infoDialogData.confirmBtnText"
      :cancel-btn-text="infoDialogData.cancelBtnText"
      @onConfirm="deactivateArrayOfUsers"
    />
    <SuccessPopup
      ref="successPopup"
      :text="successMessage"
    />
  </div>
</template>

<script>
import hasPermission from '@/utils/permission';
import linkGenerator from '../../../constants/linkGen';
import InfoDialog from '../../popups/InfoDialog';
import AlertErrorMsg from '../../profile/AlertErrorMsg';
import CommonDialog from '../../popups/CommonDialog';
import CaseClientsItem from './CaseClientsItem';
import TableHeader from '../../table/TableHeader';
import DeactivateItemPopUp from '../../popups/DeactivateItemPopUp';
import Loader from '../../loader/Loader';
import checkAll from '../../../mixins/checkAll';
import ArrowDown from '../../icons/ArrowDown';
import UserIcon from '../../icons/UserIcon';
import SuccessPopup from '@/components/popups/SuccessPopup.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import Pagination from '@/components/common/Pagination.vue';
import errorHandler from '@/mixins/errorHandler';
import {createRemoveDialog} from '@/constants/infoDialogData';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import tableResizer from '@/mixins/tableResizer';

export default {
  name: 'CaseClientsTable',
  components: {
    SuccessIcon,
    Pagination,
    Tooltip,
    Loader,
    UserIcon,
    ArrowDown,
    DeactivateItemPopUp,
    CaseClientsItem,
    TableHeader,
    AlertErrorMsg,
    CommonDialog,
    InfoDialog,
    SuccessPopup
  },
  mixins: [checkAll, errorHandler, tableResizer],
  props: {
    searchText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      infoDialogData: {
        dialogTitle: '',
        dialogSubtitle: '',
        dialogText: '',
        confirmBtnText: '',
        cancelBtnText: '',
      },
      loadFlag: false,
      caseId: this.$route.params.slug,
      keySearch: '',
      roles: '',
      sortBy: 'userName',
      order: 'asc',
      page: 1,
      size: 10,
      count: 0,
      pageSize: 2,
      users: [],
      errorMessage: '',
      successMessage: '',
      headerType: 'default',
      selectedFlag: false,
    };
  },
  computed: {
    tableData() {
      return this.users;
    }
  },
  watch: {
    searchText() {
      this.getClients();
    },
    '$route.query.page': {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.page = newVal;
          this.getClients();
        } else {
          this.page = 1;
        }
      }
    }
  },
  mounted() {
    this.page = this.$route.query.page || 1;
    this.getClients();
  },
  methods: {
    hasPermission,
    unselectAll() {
      this.users.forEach((item) => {
        item.isActive = false;
      });
    },
    changeCheckbox(item) {
      this.$emit('changeCheckbox', item, this.title);
    },
    openDeactivatePopup() {
      this.$refs.contactsPopup.openPopup();
    },
    openDeactivatePopupUser() {
      this.$refs.commonDialogDeleteUser.openPopups();
    },
    linkGen(pageNum) {
      return linkGenerator(pageNum, '/cases/:slug/clients');
    },
    sortedBy(filterName) {
      this.order = filterName === this.sortBy && this.order === 'desc' ? 'asc' : 'desc';
      this.sortBy = filterName;
      this.getClients();
    },
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
      });
    },
    getClients() {
      const params = {
        sortBy: this.sortBy,
        keySearch: this.fixedEncodeURIComponent(this.searchText),
        order: this.order,
        page: this.page,
        size: 10
      };

      this.$load(async () => {
        this.loadFlag = true;
        await this.$api.cases
          .getCasesClients(this.caseId, params)
          .then((res) => {
            this.count = res.data.body.totalPages;
            this.pageSize = res.data.body.size;
            this.users = res.data.body.content.map(i => {
              i.isActive = false;
              return i;
            });
          }, (error) => {
            this.handleResponseError(error);
          });
        setTimeout(() => {
          this.loadFlag = false;
        }, 1000);
      });
    },
    confirmDeactivateUser(user) {
      this.infoDialogData = createRemoveDialog('custodian');
      this.$refs.infoDialog.openPopup(user);
    },
    confirmDeactivateUserList(userlist) {
      this.infoDialogData = createRemoveDialog('custodians');
      this.$refs.infoDialogDeactivateUserList.openPopup(userlist);
    },
    deleteUser(user) {
      this.openDeactivatePopupUser();
      this.$load(async () => {
        await this.$api.cases.deleteCasesUser(this.caseId, user.publicId).then(() => {
          this.$refs.infoDialog.closePopup();
          this.openDeactivatePopupUser();
          this.getClients(this.order);
        }, (error) => {
          this.handleResponseError(error);
        });
      });
    },
    deactivateArrayOfUsers(arrayOfCheckedUsers) {
      const userIds = arrayOfCheckedUsers.map(user => user.publicId);
      userIds.toString();
      this.$load(async () => {
        this.loadFlag = true;
        await this.$api.cases.deleteCasesUser(this.caseId, userIds).then(() => {
          this.$refs.infoDialogDeactivateUserList.closePopup();
          this.openDeactivatePopupUser();
          this.getClients();
        }, (error) => {
          this.handleResponseError(error);
        });
      });
    },
    resendInvite(id, userName) {
      this.$load(async () => {
        await this.$api.cases.reInviteClientToCase({caseId: this.caseId, publicId: id}).then(() => {
          this.successMessage = `${userName} has been re-invited`;
          this.$refs.successPopup.openPopup();
        }, (error) => {
          this.handleResponseError(error);
        });
      });
    },
  }
};
</script>


<style scoped>
@import '../../../assets/css/tableResizer.css';

/* table header */
.table-header.active {
  justify-content: space-between;
  padding-right: 13px;
  background-color: var(--accent-color);
}

.table-header-box svg path {
  fill: var(--input-placeholder-value-color);
  transition: all 0.3s;
}

.table-header-box:hover svg:first-child path {
  fill: var(--accent-color);
}

.arrow-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.arrow-icon svg path {
  fill: var(--light-gray);
}

.table-header.active .holder-deactivate-btn {
  margin-left: auto;
  width: fit-content;
}

.table-header.active th {
  padding: 22px 15px 21px;
}

.case-clients-table {
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  position: relative;
}

.dialog-message-description {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #696F79;
  display: block;
  width: 100%;
}

.checkbox-wrap .checkbox-unselect {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #FFFFFF;
  text-transform: initial;
  cursor: pointer;
  padding: 2px 0 0;
}
</style>
